import React, { useEffect, useRef, useState } from 'react';
import { Modal, Button, Menu, MenuProps, Layout, Form, Checkbox, Col, Row } from 'antd';
import { GetRequest, PutRequest } from '../../utils/api';
import { Typography } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { Notification } from '../../components/notification/notification';
import InputComponent from '../../components/input/input';
import CustomLoader from '../../components/loader';
import CustomDropDown from '../../components/customDropDown/customDropDown';
import { useForm } from 'react-hook-form';
import CustomDatePicker from '../../components/datePicker/datepicker';
import { isMobile } from 'react-device-detect';

const { Sider, Content } = Layout;
const { Title, Text } = Typography;
interface Props {
    open: boolean;
    close: Function;
}

const SettingsWindow: React.FC<Props> = ({ open, close }: Props) => {

    const [loading, setLoading] = useState<boolean>(true);
    const [currentModule, setCurrentModule] = useState<any>();

    const [current, setCurrent] = useState<any>();

    const menuList: any = useRef();
    const mainSettings: any = useRef();

    const showModal = () => {

        setLoading(true);

        GetRequest("users/platform/api/settings-menu?page=0&size=10").then(async (res: { records: any[] }) => {

            mainSettings.current = res.records;

            menuList.current = mainSettings.current.map((item: any) => {
                return {
                    label: item.menuName,
                    key: item.menuCode
                }
            });

            setCurrent(menuList.current[0].key);
            setCurrentModule(mainSettings.current[0]);
            setLoading(false);
        });

    };


    const handleCancel = () => {
        // setIsModalVisible(false);
        close();
    };

    const onClick: MenuProps['onClick'] = (e) => {
        setCurrentModule(mainSettings.current.find((item: any) => item.menuCode === e.key));
        setCurrent(e.key);
    };

    const [showSettings, setShow] = useState<boolean>(false);

    useEffect(() => {

        try {
            const userInLocalStorageStr: any = localStorage.getItem("user");
            const user = JSON.parse(userInLocalStorageStr);

            if (user.roleName === "Administrator") {
                setShow(true);
            }
        } catch (err) {
            console.error("Error showing Settings");
        }
        showModal();
    }, []);

    if (isMobile) {

        return (<>
            {showSettings && <Modal
                title={<Title level={4} className='text-primary my-2 py-2 text-lg'>{"Administrator Settings"}</Title>}
                open={open}
                onCancel={handleCancel}
                footer={null}
                width="80%"
                bodyStyle={{ padding: 0, width: "100%" }}
            >

                {!loading && <div className='text-center py-5'>
                    <p>
                        Admin Settings are not
                        available in Mobile <br />
                        Please open in a Desktop.
                    </p>
                </div>}
            </Modal>}
        </>
        );

    }
    return (<>
        {showSettings && <Modal
            title={<Text className='text-primary my-2 py-2 text-lg'>{"Administrator Settings"}</Text>}
            open={open}
            onCancel={handleCancel}
            footer={null}
            width="60%"
            styles={{
                content: {
                    padding: '4px'
                },
                header : {
                    paddingTop: "12px",
                    paddingBottom: "8px",
                    paddingLeft: "8px"
                }

            }}
        >

            {!loading && <Layout style={{ height: "50vh" }}>
                <Layout className='admin-settings h-100'>
                    <Sider className='bg-white h-100'>
                        <Menu className='bg-white h-100' onClick={onClick} items={menuList.current} selectedKeys={[current]}>
                        </Menu>
                    </Sider>
                    <Content className='bg-white h-100'>
                        <SettingsForm module={currentModule}></SettingsForm>
                    </Content>
                </Layout>
            </Layout>}
        </Modal>}
    </>
    );
};


const SettingsForm: React.FC<{ module: any }> = ({ module }: any) => {

    const [settings, setSettings] = useState<any>();

    const [loading, setLoading] = useState<boolean>(true);
    const [saving, setSaving] = useState<boolean>(false);
    const [formData, setFormData] = useState<any>();

    useEffect(() => {

        setLoading(true);

        if (module) {

            GetRequest(module.detailPageBlueprintUrl).then((res) => {

                setSettings(res);

                GetRequest(res.dataApi).then((response) => {

                    const configObject: any = {};
                    console.log(response);
                    response.settings.forEach((item: any) => {
                        configObject[item.apiName] = item.value;
                    });

                    setFormData(configObject);

                    setLoading(false);
                });
            });

        }

    }, [module]);

    const [form] = Form.useForm();

    const onFinish = () => {
        setSaving(true);
        // console.log(values);
        // console.log(formData);
        PutRequest(settings.dataApi as string, formData).then(() => {
            Notification("success", "Settings saved successfully");
            setSaving(false);
        });
    };



    const handleFieldChange = (field: string, value: any) => {
        setFormData((prev: any) => {
            return { ...prev, [field]: value };
        });
    };

    const { control, formState: { errors } } = useForm<any>({});

    if (loading) {
        return <div className='text-center mt-5'> <CustomLoader></CustomLoader> </div>
    } else {

        return (
            <div className='px-3 py-2'>

                <Title level={5} className='text-primary mt-2 mb-3'>{module.menuName}</Title>

                <div className='mt-3'>
                    <Form
                        form={form}
                        initialValues={{ remember: true }}
                        onFinish={onFinish}
                        autoComplete="off"
                        layout='horizontal'
                        labelAlign='left'

                    >
                        {settings.settings.map((item: any) => {
                            return (
                                <div>
                                    <Row className='my-2'>
                                        <Col span={16}>
                                            <label className="font-medium mb-2 block">{item.displayName}</label>
                                        </Col>
                                        <Col span={8}>
                                            {(() => {
                                                switch (item.fieldType) {
                                                    case "text":
                                                        return (
                                                            <InputComponent
                                                                onChange={(value: any) => handleFieldChange(item.field, value.target.value)}
                                                                placeholder={item.placeholder}
                                                                value={formData?.[item.field]}
                                                            />
                                                        );
                                                    case "textBox":
                                                        return (
                                                            <InputComponent
                                                                onChange={(value: any) => handleFieldChange(item.field, value.target.value)}
                                                                placeholder={item.placeholder}
                                                                value={formData?.[item.field]}
                                                            />
                                                        );
                                                    case "dropDown":
                                                        return (
                                                            <CustomDropDown
                                                                api={item.api}
                                                                dropdownCode={item.dropdownCode}
                                                                dropdownValue={item.dropdownValue}
                                                                onChange={(value: any) => handleFieldChange(item.field, value)}
                                                                value={formData?.[item.field]}
                                                                title={item.displayName}
                                                                placeholder={item.placeholder}
                                                                control={control} name={item.field}
                                                            />
                                                        );
                                                    case "textArea":
                                                        return (
                                                            <TextArea
                                                                rows={4}
                                                                placeholder={item.placeholder || "Enter details here"}
                                                                onChange={(value: any) => handleFieldChange(item.field, value.target.value)}
                                                                value={formData?.[item.field]}
                                                            />
                                                        );

                                                    case "checkBox":
                                                        return (
                                                            <Checkbox
                                                                className='my-2'
                                                                onChange={(value: any) => handleFieldChange(item.field, value.target.checked)}
                                                                checked={formData?.[item.field]}
                                                            >
                                                            </Checkbox>
                                                        );


                                                    case "calendar":
                                                        return (
                                                            <>
                                                                <CustomDatePicker
                                                                    title={item?.displayName}
                                                                    onChange={(value: any) => handleFieldChange(item.field, value.format("YYYY-MM-DD"))}
                                                                    rules={item?.rules[0]}
                                                                    placeholder={item?.placeholder}
                                                                    control={control}
                                                                    name={item.field}
                                                                    id={item.field}
                                                                />
                                                            </>
                                                        );
                                                    default:
                                                        return (
                                                            <>
                                                                <InputComponent
                                                                    onChange={(value: any) => handleFieldChange(item.field, value.target.value)}
                                                                    placeholder={item.placeholder}
                                                                    value={formData?.[item.field]}
                                                                />
                                                            </>
                                                        );
                                                }
                                            })()}
                                        </Col>
                                    </Row>



                                </div>)

                        })}

                        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                            <div className='text-right mt-2'>
                                <Button loading={saving} type="primary" htmlType="submit">
                                    Save
                                </Button>
                            </div>
                        </Form.Item>
                    </Form>
                </div >
            </div >
        )
    }
}

export default SettingsWindow;



